module.exports = " <navbar></navbar> <div class=container> <h1>About</h1> <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae ab dolores asperiores aliquam deleniti saepe. Ipsam, cum possimus nihil iure quidem nobis ex earum dolor, at odio dolores perspiciatis. Quasi.</p> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
 ** module id = 48
 ** module chunks = 1
 **/